'use client'
import React from 'react'
import styles from './styles.module.scss'
import { useTranslations } from 'next-intl'

interface WithoutPlayersProps {
  emptyPlayers: Array<any>
  showWaitPlayers?: boolean
}
const WithoutPlayers: React.FC<WithoutPlayersProps> = ({
  emptyPlayers,
  showWaitPlayers = true,
}) => {
  const t = useTranslations('translation')
  return (
    <>
      {emptyPlayers.map((item, idx) => (
        <div key={`empty_player_${idx}`}>
          <div style={{ opacity: item.opacity }}>{item.number}</div>
          <div>
            <div
              className={styles.emptyPlayer}
              style={{
                width: item.sizeName + 'px',
                opacity: item.opacity,
                right: 'initial',
                height: idx === 0 ? '14px' : '12px',
              }}
            />
          </div>
          <div>
            <div
              className={styles.emptyPlayer}
              style={{
                width: item.sizeName + 'px',
                opacity: item.opacity,
                right: '0',
                height: idx === 0 ? '14px' : '12px',
              }}
            />
          </div>
        </div>
      ))}
      {showWaitPlayers && (
        <div className={styles.waitForPlayers}>
          <span>{t('waitForPlayers')}</span>
        </div>
      )}
    </>
  )
}

export default WithoutPlayers
